import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/icons/mss.png'


const _hoisted_1 = {
  class: "navbar is-fixed-top has-background-light is-transparent",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "media_solusi_sukses",
  width: "62"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-item" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title is-mobile adlam-display-regular" }, "Media Solusi Sukses")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  role: "button",
  class: "navbar-burger",
  "aria-label": "menu",
  "aria-expanded": "false",
  "data-target": "navbarBasicExample"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }),
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }),
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }),
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" })
], -1)
const _hoisted_6 = {
  id: "navbarBasicExample",
  class: "navbar-menu"
}
const _hoisted_7 = { class: "navbar-end" }
const _hoisted_8 = {
  href: "#",
  class: "navbar-item"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "NOC", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  href: "#",
  class: "navbar-item"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Visi", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  href: "#",
  class: "navbar-item"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Misi", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  href: "#",
  class: "navbar-item"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Products", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  href: "#",
  class: "navbar-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Coverage Area", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  href: "#",
  class: "navbar-item"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Partners", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  href: "#",
  class: "navbar-item"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "About Us", -1)
const _hoisted_28 = [
  _hoisted_27
]

import { RouterLink } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _directive_scroll_to = _resolveDirective("scroll-to")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(RouterLink), {
        class: "navbar-item",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, _hoisted_10)), [
          [_directive_scroll_to, '#noc']
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, _hoisted_13)), [
          [_directive_scroll_to, '#visi']
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, _hoisted_16)), [
          [_directive_scroll_to, '#misi']
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_17, _hoisted_19)), [
          [_directive_scroll_to, '#products']
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_20, _hoisted_22)), [
          [_directive_scroll_to, '#coverage']
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_23, _hoisted_25)), [
          [_directive_scroll_to, '#partners']
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_26, _hoisted_28)), [
          [_directive_scroll_to, '#about']
        ])
      ])
    ])
  ]))
}
}

})